export enum ChooseIdentityMethodTypes {
   VERIFICATION = 'VERIFICATION', // Na etapie wyboru weryfikacji (bank / mObywatel)
   IDENTITY = 'IDENTITY' // Na etapie wyboru metody uzupełnienia danych (formularz / mObywatel)
}

export enum SelectedIdentityMethodTypes {
   DEFAULT_METHOD = 'DEFAULT_METHOD',
   MOBYWATEL = 'MOBYWATEL',
   VIDEO_VERIFICATION = 'VIDEO_VERIFICATION'
}

export interface IChooseIdentityMethodPageProps {
   chooseIdentityMethodType: ChooseIdentityMethodTypes;
}

export interface IChooseIdentityMethodSectionProps {
   isIdentityPage: boolean;
   handleOnIdentityMethodSelect: (selectedIdentityMethod: SelectedIdentityMethodTypes) => void;
   chooseIdentityPageTextContents: (path: string) => string;
}